module.exports = __webpack_public_path__ + "img/vk(white)-hover.be5c089f.svg";